<template>
  <vx-card :title="visibleRes && form.getFieldValue('from_date') ?
   `Revenue Report From ${form.getFieldValue('from_date')} To ${form.getFieldValue('to_date')}` :
   title">
    <div v-show="visibleRes">
      <Actions
        class="mb-5"
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result && result.length">
        <div ref="contentPdf">
          <a-table :dataSource="result" :columns="columns" :pagination="false" >
            <span slot="date" slot-scope="text,record">
              {{ setDateFormat(record.from) +' - '+ setDateFormat(record.to) }}
            </span>
            <span slot="tax" slot-scope="text,record">
              {{ record.total_tax.toFixed(2) }}
            </span>
            <span slot="total" slot-scope="text,record">
              {{ record.total.toFixed(2) }}
            </span>
            <span slot="profit" slot-scope="text,record">
              {{ record.profit.toFixed(2) }}
            </span>
          </a-table>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Responsible Lawyer">
              <a-radio-group
                v-decorator="['which_user',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]"
                @change="handleChangeUser">
                <a-radio :style="radioStyle" :value="1">
                  All Lawyers
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Responsible Lawyer
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <SelectOption
              v-show="responsible_value === 2"
              url="/account/list/"
              label="User"
              field="responsible"
              :required="false"
              method="get"
              mode="multiple"
              placeholder="Find A User"
              class="w-full self-end"
            />
          </div>
          <div class="flex flex-col md:flex-row">
            <a-form-item label="Select Client/Matter">
              <a-radio-group
                v-decorator="['which_client_matter',{ initialValue: 1,rules: [{ required: false, message: 'this field is required.' }] }]"
                @change="handleMatterClient">
                <a-radio :style="radioStyle" :value="1">
                  All Clients
                </a-radio>
                <a-radio :style="radioStyle" :value="2">
                  Specific Client
                </a-radio>
                <a-radio :style="radioStyle" :value="3">
                  Specific Matter
                </a-radio>
              </a-radio-group>
            </a-form-item>
            <selectSearch
              v-show="checked_matter_client === 3"
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_matter="true"
              @selectSearch="handleSearch"
            />
            <selectSearch
              v-show="checked_matter_client === 2"
              :required="false"
              url="/contact/query/"
              :options="optionSearchContact"
              class="self-center mt-8 md:mt-0 w-full"
              :is_include_matter="false"
              @selectSearch="handleSearch"
            />
          </div>
          <SelectOption url="/dictionary/practice-area/" label="Practice Area" placeholder="Practice Area"
                        field="practice_area" method="get"/>
          <DateRangeComponent :dateForm="form" class="mt-5"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','RevenueReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>

import SelectOption from '../../forms/SelectOptionSingle'
import selectSearch from '../../forms/selectSearch'
import axios from '@/axios'
import mixin from '../../mixin/mixin'
import DateRangeComponent from "@/components/date/DateRangeComponent";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";

const columns = [
  {
    title: 'Date',
    dataIndex: 'from',
    key: '1',
    scopedSlots: {customRender: 'date'},

  }, {
    title: 'Total Disbursement',
    dataIndex: 'total_disbursement',
    key: '2',
  },
  {
    title: 'Total Operation',
    dataIndex: 'total_expense',
    key: '3',
  },
  {
    title: 'Total Tax',
    dataIndex: 'total_tax',
    key: '4',
    scopedSlots: {customRender: 'tax'},
  },
  {
    title: 'Total Income',
    dataIndex: 'total',
    key: '5',
    scopedSlots: {customRender: 'total'},
  },
  {
    title: 'Total Profit',
    dataIndex: 'profit',
    key: '6',
    scopedSlots: {customRender: 'profit'},
  }
]

export default {
  name: "ComponentRevenue",
  mixins: [mixin],
  components: {
    BtnSubmitReport,
    Actions,
    ExportPdf,
    DateRangeComponent,
    SelectOption,
    selectSearch
  },
  data() {
    return {
      responsible_value: null,
      checked_matter_client: null,
      columns,
      title:'Revenue',
      radioStyle: {
        display: 'block',
        height: '40px',
        lineHeight: '30px',
      },
    }
  },
  methods: {
    handleChangeUser({target: {value}}) {
      if (value === 1)
        this.form.setFieldsValue({ user: [] })
      this.responsible_value = value
    },
    handleReport() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$refs.reportSubmit.loading = true
            const query = []
            if (values.matter) query.push({field: 'matters', condition: '=', value: values.matter})
            if (values.contact) query.push({field: 'to_contact', condition: '=', value: values.contact})
            if (values.practice_area) query.push({
              field: 'matters__practice_area',
              condition: '=',
              value: values.practice_area
            })
            if (values.responsible && values.responsible.length) query.push({
              field: 'matters__responsible',
              condition: 'in',
              value: values.responsible
            })
            const {data} = await axios.post('billing/report/revenue/', {query: query.length ? query : undefined, from : values.from_date, to : values.to_date })
            this.visibleRes = true
            this.result.push(data)
          } catch (e) {
            this.visibleRes = false
            this.$message.error('Server Error')
            throw new Error(e)
          } finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    }
  }
}
</script>

<style>
@import "../../style/style.css";
</style>
